// export const SSO_URI = 'https://localhost:3400'
// export const BSR_URI = 'http://localhost:3500/'
// export const SERVISE_URI = 'https://localhost:44379/'
// export const PATH_APPLICATION = "Admin";
// export const BSR_SSO_PATH = "bextsa";   
// export const PATH_SSO = "Auth";
// export const URL_REPORTS = "https://localhost:44379/Reportes/Reportes.aspx";

// export const BSR_URI = 'https://devbsr.bextsa.com:3301'

// export const SSO_URI = 'https://devbsr.bextsa.com:3201'

// export const SERVISE_URI = 'https://bsr-sso-services.azurewebsites.net/'

export const BSR_URI = window.__RUNTIME_CONFIG__.BSR_APP_URI;
export const SSO_URI = window.__RUNTIME_CONFIG__.BSR_SSO_URI;
export const SERVISE_URI = window.__RUNTIME_CONFIG__.API_SERVICES_URI;
export const PATH_APPLICATION = window.__RUNTIME_CONFIG__.PATH_APPLICATION;
export const PATH_SSO = window.__RUNTIME_CONFIG__.PATH_SSO;
export const URL_REPORTS = window.__RUNTIME_CONFIG__.URL_REPORTS;

//true para concatenar el código y la descripción del mensaje warnings y exceptions
//false solo para la descripción del mensaje
export const CODE_MESSAGE = true;
//Mostrar/ocultar el IconButton de MFA (URosario true)
export const SHOW_MFA = false;
//Mostrar/ocultar información conectado desde IP....
export const SHOW_CONNECTION_IP = true;